import { composeMask } from '@salutejs/plasma-new-hope/css';

import { TextFieldComponent } from '../TextField/TextField';

export const Mask = composeMask(TextFieldComponent);
